import * as Departments from 'Modules/DepartmentModule';
import { Department } from '../EnumTypes/ActionEnumTypes';

const init = () => ({
  type: Department.GET_DEPARTMENTS_INIT,
});

export const success = (data) => ({
  type: Department.GET_DEPARTMENTS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: Department.GET_DEPARTMENTS_FAILURE,
});

const getDepartments = (params) => async (dispatch) => {
  dispatch(init());
  try {
    const response = await Departments.Connector.getDepartments(params);
    dispatch(success(response.data));
    return response.data;
  } catch (err) {
    dispatch(failure());
    return false;
  }
};

export default getDepartments;
